import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { SelectItem } from "@/components/ui/form/Select";
import type { CustomerServiceTopicStoryblok } from "@/generated/sb/sb-types";

export const CustomerServiceTopicBlok = ({ blok }: BlokProps<CustomerServiceTopicStoryblok>) => {
	return (
		<BlokWrap editable={blok} asChild>
			<SelectItem id={blok.value} textValue={blok.label}>
				{blok.label}
			</SelectItem>
		</BlokWrap>
	);
};
